
// Firebase configuration - automatically generated from environment variables
export const firebaseConfig = {
  "apiKey": "AIzaSyBhqQrzW7VPzVK8kTl9lq_jbXpWS8C-cJ8",
  "authDomain": "nova-web-1c61e.firebaseapp.com",
  "projectId": "nova-web-1c61e",
  "storageBucket": "nova-web-1c61e.firebasestorage.app",
  "messagingSenderId": "450130277639",
  "appId": "1:450130277639:web:32e34480cb500a1196c1a2",
  "measurementId": "G-061TTH8S5L"
};
